"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RevisionType = exports.PIPELINE_GIT_EXPORT_RETIRED_MESSAGE = exports.ImportViaPipelineCategories = exports.ImportConflictResolution = exports.PipelineViewType = void 0;
var PipelineViewType;
(function (PipelineViewType) {
    PipelineViewType[PipelineViewType["Released"] = 1] = "Released";
    PipelineViewType[PipelineViewType["MyPipelines"] = 2] = "MyPipelines";
    PipelineViewType[PipelineViewType["SharedWithMe"] = 3] = "SharedWithMe";
})(PipelineViewType || (exports.PipelineViewType = PipelineViewType = {}));
var ImportConflictResolution;
(function (ImportConflictResolution) {
    ImportConflictResolution["KeepLocal"] = "keepLocal";
    ImportConflictResolution["Replace"] = "replace";
    ImportConflictResolution["Restore"] = "restore";
})(ImportConflictResolution || (exports.ImportConflictResolution = ImportConflictResolution = {}));
var ImportViaPipelineCategories;
(function (ImportViaPipelineCategories) {
    ImportViaPipelineCategories["process"] = "process";
    ImportViaPipelineCategories["pipeline"] = "pipeline";
    ImportViaPipelineCategories["app"] = "app";
    ImportViaPipelineCategories["modules"] = "modules";
    ImportViaPipelineCategories["aiModel"] = "aiModel";
    ImportViaPipelineCategories["modelSkill"] = "modelSkill";
})(ImportViaPipelineCategories || (exports.ImportViaPipelineCategories = ImportViaPipelineCategories = {}));
exports.PIPELINE_GIT_EXPORT_RETIRED_MESSAGE = "Exporting a pipeline to a Git repository has been retired, because it replaced the repository's branch on every export. " +
    "To move a pipeline to another installation, download it as a .vf file with Download VF File in the pipeline menu (available to administrators). " +
    "To get its Nextflow files, use Download Pipeline.";
var RevisionType;
(function (RevisionType) {
    RevisionType["Patch"] = "patch";
    RevisionType["Minor"] = "minor";
    RevisionType["Major"] = "major";
})(RevisionType || (exports.RevisionType = RevisionType = {}));
